import { rgba } from 'polished'
import { FaUserGraduate } from 'react-icons/fa'
import styled from 'styled-components'

export const CardButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 250px;
  padding: 1.25rem 1rem 0.9rem;
  border: 1px solid ${props => rgba(props.theme.colors.textPrimary, 0.12)};
  border-radius: 0.75rem;
  background-color: ${props => props.theme.colors.background};
  color: ${props => props.theme.colors.textPrimary};
  text-align: center;
  transition: box-shadow 180ms ease, transform 180ms ease,
    border-color 180ms ease;

  &:hover {
    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
    border-color: ${props => rgba(props.theme.colors.primary, 0.3)};
  }

  &:focus-visible {
    outline: 3px solid ${props => rgba(props.theme.colors.primary, 0.3)};
    outline-offset: 2px;
    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 768px) {
    min-height: 230px;
    padding: 1rem 0.8rem 0.85rem;
  }
`

export const PhotoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 98px;
  height: 98px;
  margin-bottom: 1rem;
  border-radius: 50%;
  background: linear-gradient(180deg, #f7f9fc 0%, #edf1f6 100%);
  box-shadow: inset 0 0 0 4px rgba(255, 255, 255, 0.85);

  @media (max-width: 768px) {
    width: 88px;
    height: 88px;
  }
`

export const Photo = styled.img`
  width: 86px;
  height: 86px;
  border-radius: 50%;
  object-fit: cover;

  @media (max-width: 768px) {
    width: 78px;
    height: 78px;
  }
`

export const PhotoFallback = styled(FaUserGraduate)`
  width: 42px;
  height: 42px;
  color: ${props => rgba(props.theme.colors.textPrimary, 0.45)};

  @media (max-width: 768px) {
    width: 38px;
    height: 38px;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

export const Name = styled.span`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 3.2rem;
  margin-bottom: 0.45rem;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.55rem;

  @media (max-width: 768px) {
    min-height: 3rem;
    line-height: 1.45rem;
  }
`

export const Phone = styled.span`
  min-height: 1.5rem;
  font-size: 0.95rem;
`

export const ViewDetails = styled.span`
  margin-top: 1rem;
  color: ${props => props.theme.colors.primary};
  font-size: 0.92rem;
  font-weight: 500;
`
